import type {
    ProductLot,
    ProductLotStockInNoteItem,
} from '@/lib/api/product-lot-api'
import type { ProductLotOption } from './ProductLotItemsField'
import { LotOptionRow } from '@/components/lots/lot-option-row'
import { formatQty } from '@/lib/format'

// NSX/HSD hiển thị DD/MM/YYYY.
function fmtLotDate(iso?: string | null): string {
    if (!iso) return ''
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return ''
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    return `${dd}/${mm}/${d.getFullYear()}`
}

function datesLine(
    nsx?: string | null,
    hsd?: string | null,
): string | undefined {
    const parts: string[] = []
    if (nsx) parts.push(`NSX ${fmtLotDate(nsx)}`)
    if (hsd) parts.push(`HSD ${fmtLotDate(hsd)}`)
    return parts.length ? parts.join(' · ') : undefined
}

/** Option cho lô có sẵn (fetch từ danh sách active) — render đầy đủ: ảnh + 3 dòng. */
export function productLotToOption(l: ProductLot): ProductLotOption {
    const unit = l.product_unit ?? ''
    const qty = `${formatQty(l.quantity_available)}${unit ? ` ${unit}` : ''}`
    return {
        value: l.id,
        label: `${l.code} — ${l.product_name ?? ''}`,
        available: l.quantity_available,
        unit: l.product_unit,
        render: () => (
            <LotOptionRow
                title={l.product_name ?? l.code}
                code={l.code}
                chips={[l.position_code]}
                qty={qty}
                thirdLine={datesLine(l.manufactured_date, l.expiry_date)}
                imageSlot
                imageUrl={l.product_image_url}
            />
        ),
    }
}

/** Option seed (lô đã có trong phiếu khi sửa) — render đầy đủ như fetched (ảnh +
 *  3 dòng); riêng số lượng là KL trong phiếu (lô pending chưa có tồn khả dụng). */
export function productNoteItemToOption(
    it: ProductLotStockInNoteItem,
): ProductLotOption {
    const code = it.product_lot_code ?? it.product_lot_id
    const unit = it.product_unit ?? ''
    return {
        value: it.product_lot_id,
        label: `${code} — ${it.product_name ?? ''}`,
        render: () => (
            <LotOptionRow
                title={it.product_name ?? code}
                code={code}
                chips={[it.position_code]}
                qty={`${formatQty(it.quantity)}${unit ? ` ${unit}` : ''}`}
                thirdLine={datesLine(it.manufactured_date, it.expiry_date)}
                imageSlot
                imageUrl={it.product_image_url}
            />
        ),
    }
}
